import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import Slider from 'react-slick';

import { loadGallery } from '../../redux/actions';
import './Gallery.scss'

class Gallery extends Component {
  state = {
    loading: false,
    images: undefined
  }

  componentWillMount() {
    this.setState({loading: true})
    this.props.loadGallery().then(({response: images}) => {
      this.setState({
        loading: false,
        images
      })
    })
  }

  renderGallery = () => {
    const { images } = this.state;
    const settings = {
      customPaging: (i) => (
        <a>
          <img className="img-fluid" src={images[i].thumb}/>
        </a>
      ),
      dots: true,
      dotsClass: 'slick-dots slick-thumb',
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 575,
        settings: {
          dots: false
        }
      }]
    };    
    return (
      <div className="gallery-container">
        <div className="gallery">      
          <Slider {...settings}>
            {images.map(({image: url}, idx) => (
              <div className="slide-wrap" key={idx}>
                <img src={url} alt=""/>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="container mt-md-5 mt-3">
        <DocumentTitle title="Galerija - e-BML" />
        <h1 className="mb-4">Galerija</h1>        
        {this.state.images && this.renderGallery()}
      </div>
    )
  }
}

export default connect(null, { loadGallery })(Gallery);


// WEBPACK FOOTER //
// ./src/scenes/Gallery/index.js